<template>
  <div class="form-field form-datex" :rel="name"
       v-bind:class="{'has-suffix': suffix,'form-required': requiredForm, 'form-disabled':isDisabled}">
    <div class="form-label">
      <label>{{ label }}</label>
    </div>
    <div class="form-input">
      <div class="form-input-wrapper">
        <i class="icon icon-icon_calendar"></i>
        <div class="date">
          <input type="text" v-model="internalInput" maxlength="10" :disabled="isDisabled" placeholder="jj.mm.aaaaa"/>
          <button class="bt-remove" @click="removeDate"><i class="icon icon-icon_close"></i></button>
        </div>
        <datepicker
            v-model="datepickerDefault"
            name="uniquename"
            format="yyyy-MM-dd"
            :clear-button="false"
            clear-button-icon="icon icon-icon_close"
            @selected="dateSelected"
            v-if="!isDisabled" style="width: 160px;">
        </datepicker>
        <div class="datetime" v-if="!hideTimeVue" style="width: 120px;">
          <vue-timepicker v-model="internalInputTime" :format="inputFormatTime" hide-clear-button></vue-timepicker>
          <button class="bt-remove" @click="removeTime"><i class="icon icon-icon_close"></i></button>
        </div>
        <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
      </div>
    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'FormField',
  props: ['value', 'label', 'name', 'placeholder', 'utcToLocale', 'suffix', 'formatTime', 'time', 'required', 'locale', 'hideTime', 'disabled', 'callback'],
  components: {Datepicker},
  data: function () {
    return {
      datepickerDefault: null,
      internalInput: null,
      internalInputTime: null,
      hideTimeVue: null,
      sep: '-',
      inputFormat: 'DD-MM-YYYY',
      inputFormatTime: 'HH:mm:ss',
      timePlaceholder: null,
      debounce: null,
      internalValue: null
    }
  },
  created: function () {
    this.internalValue = this.value
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.localeDate = this.locale ? this.locale : 'UTC'
    this.hideTimeVue = this.hideTime ? this.hideTime : false
    this.timePlaceholder = this.time ? this.time : '00:00:00'
    //console.log("localeDate: " + this.localeDate)

    this.setDisabled(this.disabled)
    this.modelUpdated(this.value)
  },
  methods: {
    removeTime: function () {
      this.internalInputTime = "00:00:00";
      this.setFinalDateTime()
    },
    removeDate: function () {
      this.internalInput = "00-00-0000";
      this.internalInputTime = "00:00:00";
      this.setFinalDateTime()
    },
    dateSelected: function (dateString) {
      if( dateString )
      {
        this.internalInput = moment(dateString).format(this.inputFormat);
        this.setFinalDateTime()
      }
    },
    modelUpdated: function (dateString) {
      if( dateString )
      {
        //console.log("TZ: " + this.$store.state.scope.timezone + " --> " + dateString)
        let date = moment.tz(dateString, this.$store.state.scope.timezone);
        this.internalInput = date.format(this.inputFormat);
        this.internalInputTime =  date.format('HH:mm:ss');
        //console.log(this.internalInput + " " + this.internalInputTime)
      }
    },
    setFinalDateTime: function () {

      var time = this.timePlaceholder
      if( this.internalInputTime )
      {
        time = this.internalInputTime
      }

      // get Offset
      var date = new Date(this.value);
      var offset = (date.getTimezoneOffset() / 60) > 0 ? "-0" + Math.abs(date.getTimezoneOffset() / 60) + ":00" : "+0" + Math.abs(date.getTimezoneOffset() / 60) + ":00";
      var dateLocale = moment(this.internalInput, this.inputFormat ).format('YYYY-MM-DD') + "T" + time + offset;
      var dateUtc = moment.utc(dateLocale).toISOString();

      console.log("setFinalDateTime.............................")
      console.log(this.value, date.getTimezoneOffset())
      console.log(this.internalInput + " " + time)
      console.log(dateUtc)
      console.log(".............................................")
      this.internalValue = dateUtc;

      let self = this
      setTimeout(function(){
        self.$emit('input', self.internalValue);
      }, 1000)

    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      //console.log(".....watch value", newVal, oldVal)
      this.modelUpdated(newVal)
    },
    'internalInputTime'(newVal, oldVal) {
      if (newVal != oldVal) {
        console.log(".....watch time", newVal, oldVal)
        this.setFinalDateTime(newVal)
      }
    },
    'internalValue'(newVal, oldVal) {
      console.log(".....watch internalValue", newVal, oldVal)
      this.$emit("update", this.internalValue)
      this.$emit('input', this.internalValue);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Datetime.vue